import {
  Button,
  FormControl,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
  makeStyles,
  Card,
  CardContent,
  CardMedia,
} from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import { Alert } from "@material-ui/lab";
import * as _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import * as toolAction from "../actions/toolAction";
import CustomButton from "../components/common/controls/CustomButton";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import DMModal from "../components/common/controls/DMModal";
import DMSelect from "../components/common/controls/DMSelect";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import { sortMoelService } from "../services/ModelsService";
import { DELETE_SERVICE_ERROR_MESSAGE } from "../utilities/applicationutils";
import "./pageStyles.scss";
import Loading from "../components/Loading/Loading";
import { width } from "@fortawesome/free-solid-svg-icons/faSave";
import { createNewTool } from "../actions/toolAction";
import { createNewToolService, deleteToolService } from "../services/ToolsService";
var CONTROLS_DATA = require("./ControlsData.json");
var MODELS_CONTROLS = CONTROLS_DATA.SCREENS.TOOLS;

const Tools = ({
  modelState,
  getModels,
  deleteTool,
  createNewModel,
  updateModel,
  getRegions,
  onMoreOptionsSelected,
  onTabSelected,
  setSnackBar,
  onPageSelected,
  onCloseSelected,
  getTools,
  toolState,
  createNewTool,
  updateTool,
}) => {
  const [models, setModels] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [showNewModel, setShowNewModel] = useState(false);
  const [newModel, setNewModel] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedModel, setSelectedModel] = useState();

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const [unsaveChangePopup, setUnsaveChangePopup] = useState(false);
  const [isUnsaveChanges, setIsUnsaveChanges] = useState(false);
  const [toolName, setToolName] = useState("");
  const [toolId, setToolId] = useState("");
  const [eDesignToolId, seteDesignToolId] = useState(0);
  const onNewProjectClick = () => { setToolName(""); seteDesignToolId(0); setShowNewModel(true); }


  const handleChange = (value) => {
    setSortBy(value);
  };

  const handleNewToolName = (e) => {
    setNewModel({ ...newModel, model: e.target.value });
  };

  const handleRegionNewModel = (e) => {
    setNewModel({ ...newModel, region: e.target.value });
  };

  const handleStatusNewModel = (e) => {
    setNewModel({ ...newModel, status: e.target.checked });
  };

  const onEdit = (id, data, eDesignId) => {
    setToolId(id);
    setToolName(data);
    seteDesignToolId(eDesignId)
    setShowEdit(true);
  };

  const onDelete = (id, data) => {
    setToolId(id);
    setToolName(data);
    setShowDelete(true);
  };

  const onMoreOptions = (event, modelId) => {
    setShowMoreOptions(true);
    setAnchorEl(event.currentTarget);
    setSelectedModel(modelId);
  };

  const getRegionName = (model) => {
    const arr = [...modelState?.regions?.data];
    const region = arr.find((ele) => ele?.regionId === model?.regionId);
    return region?.regionName;
  };

  const repTextValue = (model) => {
    const newm = model?.replaceableText;
    const filterData = newm.slice().sort((a, b) => a.sort - b.sort) || [];
    return filterData;
  };

  async function onUpdateModelSwitch(model, value) {
    try {
      const payload = {
        modelId: model.modelId,
        modelName: model.modelName,
        regionId: model.regionId,
        isActive: value,
      };
      await updateModel(payload);
      if (!modelState.updateModel.hasError) {
        await getModels();
        setModels(modelState.models.data);
        setSnackBar(true, "success", `${model.modelName} has been updated`);
      }
    } catch (error) {
      setShowNewModel(false);
      setSnackBar(true, "error", `Error while updating model ${model?.model}`);
    }
  }

  const isModelRegionPresent = (selectedModal, regionId, data) => {
    let isPresent = false;
    for (let model of data) {
      if (
        selectedModal?.modelName.toLowerCase() ==
          model.modelName.toLowerCase() &&
        regionId == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  const onUpdateModelRegion = async (model, value) => {
    if (isModelRegionPresent(model, value, modelState.models.data)) {
      setGridData([]);
      setModels([...models]);
      setSnackBar(true, "error", "Model Region already exists");
    } else {
      try {
        const payload = {
          modelId: model.modelId,
          modelName: model.modelName,
          regionId: value,
          isActive: model.status,
        };
        await updateModel(payload);
        if (!modelState.updateModel.hasError) {
          setSnackBar(true, "success", `Region name updated`);
          await getModels();
          setModels(modelState.models.data);
          setSnackBar(true, "success", `${model.modelName} has been updated`);
        }
      } catch (error) {
        setShowNewModel(false);
        setSnackBar(
          true,
          "error",
          `Error while updating model ${model?.model}`
        );
      }
    }
  };

  const onUpdateModelName = async (value, model) => {
    const { isSame, isPresent } = isModelPresent(
      value,
      model,
      modelState.models.data
    );
    if (isSame) {
      return;
    }
    if (isPresent) {
      setSnackBar(true, "error", "Model Name already exists");
      setGridData([]);
      setModels([...models]);
    } else {
      try {
        const payload = {
          modelId: model.modelId,
          modelName: value,
          regionId: model.regionId,
          isActive: model.status,
        };
        await updateModel(payload);
        if (!modelState.updateModel.hasError) {
          setSnackBar(true, "success", `Model name updated`);
          await getModels();
          setModels(modelState.models.data);
          setSnackBar(true, "success", `${value} has been updated`);
        }
      } catch (error) {
        setShowNewModel(false);
        setSnackBar(
          true,
          "error",
          `Error while updating model ${model?.model}`
        );
      }
    }
  };

  useEffect( () => {
    const fetchTools = async () => {
      try {
        await getTools();
      } catch (error) {
        console.log("get tools fails", error);
      }
    }
    fetchTools()
  }, [getTools]);

  
  useEffect(() => {
    const ctrlData = [];
    toolState &&
      toolState.forEach((model) => {
        ctrlData.push({
          rowKey: model.toolId,
          toolName: model.toolName,
          eDesignToolId: model.eDesignToolId,
          rowValue: [
            {
              colType: "grid-label",
              colOptions: {
                width: "100px",
                value: model.toolName,
                tab: "tools",
                model: model,
                onUpdate: onUpdateModelName,
              },
            },
            {
              colType: "grid-actions",
              colOptions: [
                {
                  name: "edit",
                  tab: "tools",
                  action: (e) => onEdit(model.toolId, model.toolName, model.eDesignToolId),
                  width: "100px",
                },
                {
                  name: "delete",
                  action: () => onDelete(model.toolId, model.toolName),
                },
              ],
            },
          ],
        });
      });
    setGridData(ctrlData);
  }, [toolState, searchValue, sortBy, isUnsaveChanges]);
  
  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 222,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "95% 5%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Arial",
      fontWeight: "500",
    },
  }));

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [anchorEl, setAnchorEl] = React.useState(null);


  const handleSearch = _.debounce(function (val) {
    setSearchValue(val?.toLowerCase());
  }, 700);

  const isModelPresent = (modelName, selectedModel, data) => {
    let isPresent = false;

    if (modelName === selectedModel.modelName) {
      return { isSame: true, isPresent };
    }

    for (let model of data) {
      if (
        modelName.toLowerCase() == model.modelName.toLowerCase() &&
        selectedModel.regionId == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }

    return { isSame: false, isPresent };
  };

  const isModelPresentInNew = (modelName, selectedModel, data) => {
    let isPresent = false;
    for (let model of data) {
      if (
        modelName.toLowerCase() == model.modelName.toLowerCase() &&
        selectedModel.region == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  const handleCreateModel = async () => {
    if(toolName && eDesignToolId){
      setLoading(true);
    try {
      const payload = {
        toolName: toolName,
        eDesignToolId: parseInt(eDesignToolId)
      };
      await createNewToolService(payload).then( async (response) => {
        await getTools();
        setSnackBar(true, "success", `Created new tool: ${toolName}`);
        setLoading(false);
        setShowNewModel(false);
      })
          .catch((error) =>{
            setSnackBar(true,"error", error?.response?.data?.errorMessage || DELETE_SERVICE_ERROR_MESSAGE);
            setLoading(false);
            setShowNewModel(false);
          })
    } catch (error) {
      setShowNewModel(false);
      setSnackBar(true,"error",`Error while creating a new tool${toolName}`);
    }
  } 
  else{
      setSnackBar(true, "error", `Please enter tool name!`);
      setLoading(false);
  }
  };

  const handleEditTool = async () => {
    if(toolName && eDesignToolId){
      setLoading(true);
    try {
      const payload = {
        toolId: toolId,
        toolName: toolName,
        eDesignToolId: eDesignToolId
      };
      await updateTool(toolId, payload);
      getTools();
      setSnackBar(true, "success", `Tool updated: ${toolName}`);
      setLoading(false);
      setShowEdit(false);
    } catch (error) {
      setShowEdit(false);
      setSnackBar(true, "error", `Error while updating a new tool`);
    }
  }
    else{
      setSnackBar(true, "error", `Please enter tool name!`);
      setLoading(false);
  }
  };

  const deleteConfirm = async () => {
    try {
      const payload = {
        toolId: toolId,
        toolName: toolName,
      };
      await deleteToolService(payload.toolId).then( async (response) => {
      await getTools();
      setSnackBar(true, "success", `${toolName} has been deleted.`);
      setLoading(false);
      setShowDelete(false);
    })
    .catch((error) =>{
      setSnackBar(true,"error", error?.response?.data?.errorMessage || DELETE_SERVICE_ERROR_MESSAGE);
      setLoading(false);
      setShowDelete(false);
    }) 
  }   catch (error) {
      setSnackBar(true, "error", `Error while deleting model ${toolName}`);
    }
  };


  return (
    <div container className="page-container content-center">
      <Loading open={loading} />
      <Grid container xs={12} md={11} className="page-content">
        {/* <Grid container item xs={12} md={5} className="page-menu"></Grid> */}

        <Grid item container xs={12} md={12} justify="flex-end">
          <CustomButton
            id="newModel"
            showGradient={true}
            variant="contained"
            color="primary"
            disabled={false}
            name="Add Tool"
            onClick={onNewProjectClick}
          />
        </Grid>
        <Grid item container xs={12} md={10}>
          {gridData?.length > 0 && (
            <DMGrid
              key={Math.random()}
              headers={MODELS_CONTROLS.GRID_HEADERS}
              headerClassName={classes.gridHeaderColumns}
              data={gridData}
              loading={loading}
              setGridData={(t) => {
                setGridData(t);
              }}
            />
          )}{" "}
        </Grid>
        <DMModal open={showNewModel} onClose={() => setShowNewModel(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">New Tool</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <TextField
                id="outlined-basic-userName"
                label="Tool Name"
                variant="outlined"
                autoComplete="off"
                type="text"
                value={toolName}
                onChange={(e) => setToolName(e.target.value)}
              />
              <TextField
                id="outlined-basic-userName"
                label="eDesign Tool Id"
                variant="outlined"
                autoComplete="off"
                type="number"
                value={eDesignToolId}
                onChange={(e) => seteDesignToolId(e.target.value)}
              />
              <Grid item xs={12} container style={{ justifyContent: "center" }}>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      setShowNewModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleCreateModel}
                    // disabled={isDisabled}
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </DMModal>
        <DMModal open={showEdit} onClose={() => setShowEdit(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">Edit Tool</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <TextField
                id="outlined-basic-userName"
                label="Tool Name"
                variant="outlined"
                autoComplete="off"
                type="text"
                value={toolName}
                onChange={(e) => setToolName(e.target.value)}
              />
              <TextField
                id="outlined-basic-userName"
                label="eDesign Tool Id"
                variant="outlined"
                autoComplete="off"
                type="text"
                value={eDesignToolId}
                onChange={(e) => seteDesignToolId(e.target.value)}
              />
              <Grid item xs={12} container style={{ justifyContent: "center" }}>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      setShowEdit(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleEditTool}
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </DMModal>
        <DMDeleteDialog
          open={showDelete}
          onClose={() => setShowDelete(false)}
          // title={"Are you sure to delete?"}
          contentText={`${toolName} will be deleted.`}
          discardText={"Cancel"}
          agreeText={"OK"}
          onProceed={() => {
            deleteConfirm(toolName);
          }}
        />

        {/* Dialog for unsave chabges warning */}
        <DMDeleteDialog
          open={unsaveChangePopup}
          onClose={() => setUnsaveChangePopup(false)}
          title={"Warning"}
          contentText={`You have unsaved changes, On close you will loose all your changes. Are you sure you want to close?`}
          discardText={"Cancel"}
          agreeText={"Yes"}
          onProceed={() => {
            onCloseSelected({
              id: "",
              isClosed: true,
            });
            setUnsaveChangePopup(false);
            setIsUnsaveChanges(false);
          }}
        />
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
            setShowMoreOptions(false);
          }}
        ></Menu>
      </Grid>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert onClose={() => setShowAlert(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

const mapStateToProps = (state) => ({
  toolState: state.tool.tools.data || [],
  modelState: state.model,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getTools: async () => dispatch(toolAction.getTools()),
    createNewTool: async (requestPayload) =>
      dispatch(toolAction.createNewTool(requestPayload)),
    updateTool: async (toolId, requestPayload) =>
      dispatch(toolAction.updateTool(toolId, requestPayload)),
    deleteTool: async (requestPayload) =>
      dispatch(toolAction.deleteTool(requestPayload)),
    createNewModel: async (requestPayload) =>
      dispatch(modelAction.createNewModel(requestPayload)),
    updateModel: async (requestPayload) =>
      dispatch(modelAction.updateModel(requestPayload)),
    // getRegions: async () => dispatch(modelAction.getRegions()),
    onMoreOptionsSelected: (modelId) =>
      dispatch(miscAction.onModelSelected(modelId)),
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    // onPageSelected: (selectedPage) =>
    //   dispatch(modelAction.setModelSelectedPage(selectedPage)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tools);
